import { createSlice } from '@reduxjs/toolkit'

import { SHOP_STEPS } from '@/util/shop'

import {
  getCustomerId,
  getIsCreditCheckGranted,
  getIsLeasing,
  getPaymentType,
  getSelectedAddressId,
} from './shopOrderReducer'
import { getHasFrameAgreement, getIsOrderWithinCreditFrame } from './shopProductsReducer'

export const NAME = 'shop-progress'

const initialState = {
  activeStep: 0,
  furthestStep: 0,

  steps: [
    SHOP_STEPS.CUSTOMER,
    SHOP_STEPS.MAIN_PRODUCT,
    SHOP_STEPS.ACCESSORIES,
    SHOP_STEPS.CREDIT_CHECK,
    SHOP_STEPS.FRAME_AGREEMENT,
    SHOP_STEPS.CONTRACT,
    SHOP_STEPS.CONFIRM,
  ],
}
// @ts-ignore
export const increaseStep = () => (dispatch, getState) => {
  const activeStepId = getActiveStepId(getState())

  dispatch(goToStep(activeStepId + 1))
}
// @ts-ignore
export const decreaseStep = () => (dispatch, getState) => {
  const activeStepId = getActiveStepId(getState())

  dispatch(goToStep(activeStepId - 1))
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    goToStep: (state, { payload: targetStepId }) => {
      state.activeStep = targetStepId
      state.furthestStep = Math.max(targetStepId, state.furthestStep)
    },
    setShopOrderProgressState: (state, { payload: newState }) => ({
      ...newState,
    }),
    removeSteps: (state, { payload: removedSteps }) => {
      state.steps = state.steps.filter(step => !removedSteps.includes(step))
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const { goToStep, setShopOrderProgressState, removeSteps, reset } = actions

export default reducer

const getState = (state: any) => state[NAME]

export const getSteps = (state: any) => getState(state).steps
export const getRelevantSteps = (state: any) =>
  // @ts-ignore
  getSteps(state).filter(stepType => isStepRelevant(state, stepType))
export const getActiveStepId = (state: any) => getState(state).activeStep
export const getActiveStepType = (state: any) => getRelevantSteps(state)[getActiveStepId(state)]
export const getFurthestStepId = (state: any) => getState(state).furthestStep

export const getIsFirstStep = (state: any) => getActiveStepId(state) === 0
export const getIsFinalStep = (state: any) =>
  getActiveStepId(state) === getRelevantSteps(state).length - 1
export const getIsFurthestStep = (state: any) => getActiveStepId(state) === getFurthestStepId(state)
// @ts-ignore
export const getIsStepFinished = (state, id) => getFurthestStepId(state) > id
// @ts-ignore
export const getIsStepStarted = (state, id) => getFurthestStepId(state) >= id
// @ts-ignore
export const getIsStepActive = (state, id) => getActiveStepId(state) === id

export const getStepIdOfMainProduct = (state: any) =>
  getSteps(state).indexOf(SHOP_STEPS.MAIN_PRODUCT)

export const getIsCurrentStepValid = (state: any) => isStepValid(state, getActiveStepType(state))
export const getIsOrderValid = (state: any) =>
  // @ts-ignore
  getRelevantSteps(state).every(step => isStepValid(state, step))
// @ts-ignore
export const isStepValid = (state, stepType) => {
  switch (stepType) {
    case SHOP_STEPS.PAYMENT:
      return Boolean(getPaymentType(state))
    case SHOP_STEPS.CUSTOMER:
      return Boolean(getCustomerId(state))
    case SHOP_STEPS.CREDIT_CHECK:
      return Boolean(getIsCreditCheckGranted(state))
    case SHOP_STEPS.FRAME_AGREEMENT:
      return Boolean(getIsOrderWithinCreditFrame(state))
    case SHOP_STEPS.CONFIRM:
      return Boolean(getSelectedAddressId(state))
    default:
      return true
  }
}
// @ts-ignore
const isStepRelevant = (state, stepType) => {
  switch (stepType) {
    case SHOP_STEPS.CREDIT_CHECK:
      return getIsLeasing(state) && !getHasFrameAgreement(state)
    case SHOP_STEPS.FRAME_AGREEMENT:
      return getIsLeasing(state) && getHasFrameAgreement(state)
    case SHOP_STEPS.CONTRACT:
      return getIsLeasing(state) && !getHasFrameAgreement(state)
    case SHOP_STEPS.CONFIRM:
      return (getIsLeasing(state) && getHasFrameAgreement(state)) || !getIsLeasing(state)
    default:
      return true
  }
}
